import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType, MessageType } from '@/types/conversation.types';

export default function messageUpdate(data: MessageType): void {
  const conversationsStore = useConversationsStore();

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateMessage(data);
  }

  conversationsStore.updateCacheMessage(data);
}
